import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useAnnouncements from '@/composable/announcement';
import AnnouncementDetailContent from './AnnouncementDetailContent.vue';
export default {
  __name: 'AnnouncementModal',
  setup(__props) {
    const {
      t
    } = useI18n();
    const {
      getModalAnnouncements,
      acknowledgeAnnouncement,
      featureEnabled
    } = useAnnouncements();
    const queue = ref([]);
    const current = computed(() => queue.value[0] ?? null);
    const visible = computed(() => !!current.value);
    const isAcknowledging = ref(false);
    const justAcknowledged = ref(false);
    onMounted(async () => {
      const result = await getModalAnnouncements();
      if (result?.data?.length) {
        queue.value = result.data;
      }
    });
    const counterText = computed(() => queue.value.length > 1 ? `1 ${t('announcements.of')} ${queue.value.length}` : '');
    const dismiss = () => {
      queue.value.shift();
    };
    const acknowledge = async () => {
      if (!current.value || isAcknowledging.value) return;
      isAcknowledging.value = true;
      await acknowledgeAnnouncement(current.value.id);
      isAcknowledging.value = false;
      // Briefly show the "Acknowledged" state before advancing to the next queued item.
      justAcknowledged.value = true;
      setTimeout(() => {
        justAcknowledged.value = false;
        dismiss();
      }, 650);
    };
    const onModalUpdate = value => {
      // BModal also emits this event with `true` when it opens (see its internal
      // `show()`), not just when it closes — only treat an explicit `false` as a dismiss.
      if (value === false) {
        dismiss();
      }
    };
    return (_ctx, _cache) => {
      const _component_b_modal = _resolveComponent("b-modal");
      return _unref(featureEnabled) ? (_openBlock(), _createBlock(_component_b_modal, {
        key: 0,
        "model-value": visible.value,
        centered: "",
        "hide-header": "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        size: "lg",
        "modal-class": "os-modal",
        "body-class": "os-modal__body",
        "onUpdate:modelValue": onModalUpdate
      }, {
        default: _withCtx(() => [current.value ? (_openBlock(), _createBlock(AnnouncementDetailContent, {
          key: 0,
          announcement: current.value,
          "is-acknowledging": isAcknowledging.value,
          acknowledged: justAcknowledged.value,
          "counter-text": counterText.value,
          onClose: dismiss,
          onAcknowledge: acknowledge
        }, null, 8, ["announcement", "is-acknowledging", "acknowledged", "counter-text"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model-value"])) : _createCommentVNode("", true);
    };
  }
};